/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrganizationRole = {
    SystemAdmin: 'SYSTEM_ADMIN',
    OrganizationAdmin: 'ORGANIZATION_ADMIN',
    Member: 'MEMBER'
} as const;
export type OrganizationRole = typeof OrganizationRole[keyof typeof OrganizationRole];


export function instanceOfOrganizationRole(value: any): boolean {
    for (const key in OrganizationRole) {
        if (Object.prototype.hasOwnProperty.call(OrganizationRole, key)) {
            // @ts-ignore
            if (OrganizationRole[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrganizationRoleFromJSON(json: any): OrganizationRole {
    return OrganizationRoleFromJSONTyped(json, false);
}

export function OrganizationRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationRole {
    return json as OrganizationRole;
}

export function OrganizationRoleToJSON(value?: OrganizationRole | null): any {
    return value as any;
}

